import React from 'react'
import Header from './include/Header'
import Footer from './include/Footer'
import ScrollToTop from './include/ScrollToTop'

function Base({ children }) {

    return (
        <>
            <Header />
            <div className="pt-[160px] lg:pt-[180px]">
                {children}
            </div>
            <Footer />
            <ScrollToTop />
        </>
    )
}

export default Base